/* eslint-disable react/display-name */
import { PlusOutlined, CheckSquareOutlined, BorderOutlined } from "@ant-design/icons";
import React from "react";
import { Link } from "react-router-dom";
import { Button, Tooltip } from "antd";
import { useHistory } from "react-router-dom";
import { ExportIcon } from "components/svgs/ExportIcon";
import AdminBreadCrumb from "../../../../components/AdminBreadCrumb";
import { ImportIcon } from "components/svgs/ImportIcon";
import { FilterIcon, PrintPDFIcon } from "components/svgs";

const FlexioPoolHeader = ({
  breadCrumbs,
  buttonParams,
  showFilter,
  setShowFilter,
  hasButton = true,
  showImport = false,
  showExport = false,
  onExport,
  exporting,
  setShowImport,
  showCheckboxes = false,
  onToggleCheckboxes,
  selectedCount = 0,
  onBulkPrintPackingSlips,
  bulkPrinting = false
}) => {
  const history = useHistory();
  return (
    <div className="common-header">
      <AdminBreadCrumb breadCrumbs={breadCrumbs} />
      {hasButton && (
        <div className="buttons d-flex flex-row gap-2">
          <Tooltip title="As of May 1 2026 we have discontinued this service. If you have questions please contact us.">
            <Button disabled onClick={() => history.push("/pool-orders/new")}>
              Create Pool Order
            </Button>
          </Tooltip>
          <Button
            size="small"
            type={showCheckboxes ? "primary" : "default"}
            className="d-flex flex-row"
            onClick={onToggleCheckboxes}
            icon={showCheckboxes ? <CheckSquareOutlined /> : <BorderOutlined />}
          >
            {showCheckboxes ? "Hide Selection" : "Select Multiple"}
          </Button>
          {showCheckboxes && selectedCount > 0 && (
            <Button
              size="small"
              type="primary"
              className="svg-icon d-flex flex-row"
              onClick={onBulkPrintPackingSlips}
              loading={bulkPrinting}
            >
              Print {selectedCount} Packing Slips <PrintPDFIcon />
            </Button>
          )}
          <Button
            size={showFilter ? "normal" : "small"}
            className={`svg-icon ${showFilter && "filter"} d-flex flex-row`}
            onClick={() => setShowFilter(!showFilter)}
          >
            Filter <FilterIcon />
          </Button>
          {showImport && (
            <Tooltip title="As of May 1 2026 we have discontinued this service. If you have questions please contact us.">
              <Button
                size="small"
                type="third"
                className={`svg-icon  d-flex flex-row`}
                disabled
              >
                Import <ImportIcon />
              </Button>
            </Tooltip>
          )}
          {showExport && (
            <Button
              size="small"
              type="third"
              className={`svg-icon d-flex flex-row`}
              onClick={onExport}
              loading={exporting}
            >
              Export <ExportIcon />
            </Button>
          )}
          {buttonParams && (
            <Link to={buttonParams.link}>
              <Button type="primary" size="small">
                {buttonParams.text}
                <PlusOutlined />
              </Button>
            </Link>
          )}
        </div>
      )}
    </div>
  );
};
export default FlexioPoolHeader;
